import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppDialog } from "../../components/ui";
import {
  BANNER_ACTIVE_FILTER_HREF,
  BANNER_ACTIVE_LIMIT_BODY,
  BANNER_ACTIVE_LIMIT_PRIMARY,
  BANNER_ACTIVE_LIMIT_TITLE,
} from "./bannerFormRules";

const removeLeftoverDialogMasks = () => {
  document.querySelectorAll(".p-dialog-mask").forEach((node) => node.remove());
};

export const BannerActiveLimitDialog = ({
  visible,
  onHide,
}: {
  visible: boolean;
  onHide: () => void;
}) => {
  const navigate = useNavigate();

  useEffect(() => () => removeLeftoverDialogMasks(), []);

  return (
    <AppDialog
      visible={visible}
      onHide={onHide}
      header={BANNER_ACTIVE_LIMIT_TITLE}
      variant="form"
      primaryLabel={BANNER_ACTIVE_LIMIT_PRIMARY}
      onPrimary={() => {
        onHide();
        window.setTimeout(() => {
          navigate(BANNER_ACTIVE_FILTER_HREF);
          removeLeftoverDialogMasks();
        }, 300);
      }}
    >
      <p>{BANNER_ACTIVE_LIMIT_BODY}</p>
    </AppDialog>
  );
};
